import React from "react";
import "./banner.css";

export class Banner extends React.Component{
    render(){
        return(
            <div id="home">

                <div id="banner">
                    <h1>LCA <br/> Men's Soccer</h1>
                </div>
            </div>
        );
    }
}